import { APIClient } from 'cx-api-client-lite';

import unwrapData from 'app/libs/unwrapData';

const Manga = new APIClient({
  fetchMangaSeries: {
    path: 'list_series',
    method: 'GET',
    transformResponse: unwrapData,
  },
});

export default Manga;
